import { render, staticRenderFns } from "./BatchInitNeCfgMenu.vue?vue&type=template&id=5b16872b&"
import script from "./BatchInitNeCfgMenu.vue?vue&type=script&lang=js&"
export * from "./BatchInitNeCfgMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports